export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_COMPETITION_INFO = 'UPDATE_COMPETITION_INFO';
